import { Box } from "@material-ui/core";

import { Quote } from "../../../../api/Quote/Quote";
import QuoteAddons from "./QuoteAddons";
import { ProductSubscription } from "../../../../api/Product/ProductSubscriptionApi";
import { TopBox } from "../../../../components/TopBox";
import { BotBox } from "../../../../components/BotBox";
import { useStyles } from "../../quoteDetail.styles";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { hasAddons, hasSubscriptions } from "../../../../app/utils";
import { EQuoteType } from "../../../../api/Types";

export const AddOnSection = ({
  quote,
  subscriptions,
  isGraphVisible
}: {
  quote: Quote;
  subscriptions: ProductSubscription[];
  isGraphVisible?: boolean;
}) => {
  const classes = useStyles();
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  if (!hasAddons(quote.addons) && !hasSubscriptions(subscriptions)) {
    return null;
  }
  const isSolar = quote.type === EQuoteType.Solar;
  return (
    <Box
      bgcolor={isGraphVisible ? "#fff" : "#f7f7f7"}
      mt={"92px"}
      mb={isMoreThanSm ? "124px" : "90px"}
      position={"relative"}
    >
      {isGraphVisible ? null : (
        <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
      <Box
        textAlign={"center"}
        fontSize={isMoreThanSm ? "28px" : "20px"}
        color={"#1e073f"}
        fontWeight={500}
        width={"100%"}
        position={isGraphVisible ? "relative" : "absolute"}
        top={isGraphVisible ? "inherit" : "90px"}
      >
        Future-proof your {isSolar ? "solar" : "heating"} system
        <br />
        <span className={classes.colorOrange}>with these energy efficient {!isMoreThanSm && <br />} add-ons</span>
      </Box>
      <AddOnView subscriptions={subscriptions} quote={quote} isGraphVisible={isGraphVisible} />
      {isGraphVisible ? null : (
        <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
    </Box>
  );
};

const AddOnView = ({
  quote,
  subscriptions,
  isGraphVisible
}: {
  quote: Quote;
  subscriptions: ProductSubscription[];
  isGraphVisible?: boolean;
}) => {
  const { isMoreThanMd } = useBreakpoint();
  return (
    <Box
      display={"flex"}
      pt={isGraphVisible ? 0 : isMoreThanMd ? "50px" : "120px"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <QuoteAddons addons={quote.addons} subscriptions={subscriptions} quote={quote} />
    </Box>
  );
};
